var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"55912340b26e36392215eb65f7e92ba8a0ccb3d9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["yogobe-web@yogobe"]={id:"55912340b26e36392215eb65f7e92ba8a0ccb3d9"};
      